// ── 공통 모바일 서브컴포넌트: 로딩·빈 상태 ───────────────────────────────────

import React from 'react';
import { s } from './mobileStyles';

/** 스켈레톤 로딩 플레이스홀더 (3개 카드) */
export function LoadingPlaceholder() {
  return (
    <div style={s.loadWrap}>
      {[1, 2, 3].map((k) => (
        <div key={k} style={s.loadCard}>
          <div style={{ ...s.loadLine, width: '40%', height: 14 }} />
          <div style={{ ...s.loadLine, width: '70%', height: 12, marginTop: 8 }} />
        </div>
      ))}
    </div>
  );
}

/** 빈 상태 안내 (아이콘 + 메인 텍스트 + 서브 텍스트) */
export function EmptyState({ icon, text, sub }) {
  return (
    <div style={s.emptyWrap}>
      <div style={s.emptyIcon}>{icon}</div>
      <div style={s.emptyText}>{text}</div>
      {sub && <div style={s.emptySub}>{sub}</div>}
    </div>
  );
}
